import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast, Dialog, TextArea, Popup, Modal } from 'antd-mobile-v5';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import line_head from '../../static/images_ae/reporting/line_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import line_chest from '../../static/images_ae/reporting/line_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import line_others from '../../static/images_ae/reporting/line_others.png';
import line_heart from '../../static/images_ae/reporting/line_heart.png';
import line_lungs from '../../static/images_ae/reporting/line_lungs.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import sympton_bg from '../../static/images_ae/reporting/sympton_bg.png';
import bg_back from '../../static/images_ae/reporting/bg_back.png';
import bg_finish_go_on from '../../static/images_ae/reporting/bg_finish_go_on.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import organ_brain from '../../static/images_ae/reporting/organ_brain.png';
import organ_eye from '../../static/images_ae/reporting/organ_eye.png';
import organ_tooth from '../../static/images_ae/reporting/organ_tooth.png';
import line_brain from '../../static/images_ae/reporting/line_brain.png';
import line_eye from '../../static/images_ae/reporting/line_eye.png';
import line_tooth from '../../static/images_ae/reporting/line_tooth.png';
import { withRouter } from 'react-router-dom';
import blue_body from '../../static/images_ae/alkReport/blue_body.png';
import arrow_back from '../../static/images_ae/alkReport/arrow_back.png';
import body_organ_brain from '../../static/images_ae/alkReport/body_organ_brain.png';
import body_organ_eye from '../../static/images_ae/alkReport/body_organ_eye.png';
import line_to_brain from '../../static/images_ae/alkReport/line_to_brain.png';
import line_to_eye from '../../static/images_ae/alkReport/line_to_eye.png';
import organ_brain_blue from '../../static/images_ae/alkReport/organ_brain_blue.png';
import organ_brain_purple from '../../static/images_ae/alkReport/organ_brain_purple.png';
import organ_eye_blue from '../../static/images_ae/alkReport/organ_eye_blue.png';
import organ_eye_purple from '../../static/images_ae/alkReport/organ_eye_purple.png';
import styles from './head.module.scss';

const api = new ApiCore();

const organMap = {
    'brain': '脑部',
    'eye': '眼睛',
    'tooth': '口腔'
}

const Chest = (props: any) => {

    const [list, setList] = useState<any>([]);
    const [headSelected, setHeadSelected] = useState<any>(false);
    const [chestSelected, setChestSelected] = useState<any>(false);
    const [stomachSelected, setStomachSelected] = useState<any>(false);
    const [othersSelected, setOthersSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [selectedCount, setSelectedCount] = useState<any>(0);
    const [organs, setOrgans] = useState<any>(props.organs || {});
    const [organList, setOrganList] = useState<any>([]);
    const [activeOrgan, setActiveOrgan] = useState<any>('brain');
    const [brainIntro, setBrainIntro] = useState<any>('');
    const [eyeIntro, setEyeIntro] = useState<any>('');
    const [toothIntro, setToothIntro] = useState<any>('');
    const [value, setValue] = useState<any>('');
    const [visible, setVisible] = useState<any>(false);
    const [brainSelectedCount, setBrainSelectedCount] = useState<any>(0);
    const [eyeSelectedCount, setEyeSelectedCount] = useState<any>(0);
    const [toothSelectedCount, setToothSelectedCount] = useState<any>(0);

    useEffect(() => {
        window.document.title = 'ALK风险评估';
        initData();
        return () => {
            window.removeEventListener('popstate', onPopState);
        }
    }, [])

    useEffect(() => {
        let _selectedCount = 0;
        [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected].forEach((val: any) => {
            if (val) {
                _selectedCount++;
            }
        })
        setSelectedCount(_selectedCount);
    }, [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected])

    const initData = () => {
        window.addEventListener('popstate', onPopState)
        let _organs = props.organs;
        _organs.organs = _organs.organs.map((vvv: any) => {
            if (vvv.type === 'brain') {
                setBrainIntro(vvv.remark);
            } else if (vvv.type === 'eye') {
                setEyeIntro(vvv.remark);
            } else if (vvv.type === 'tooth') {
                setToothIntro(vvv.remark);
            }
            const _lastItem = vvv.symptoms[vvv.symptoms.length -1] || {};
            if (_lastItem && _lastItem.code === '') {
                return vvv;
            } else {
                const symptoms = vvv.symptoms.concat({
                    code: '',
                    name: '其他',
                    organCode: vvv.code
                })
                return {
                    ...vvv,
                    symptoms
                }
            }

        })
        setOrgans(_organs)
        let _list = _organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
        // 还原选中状态
        setOrganSelectedActive(_list);
    }

    const setOtherValue = (value: any) => {
        let _organs = organs;
        _organs.organs = _organs.organs.map((vvv: any) => {
            const _lastItem = vvv.symptoms[vvv.symptoms.length -1] || {};
            if (_lastItem && _lastItem.code === '') {
                const symptoms = vvv.symptoms.map((vv: any) => {
                    if (activeOrgan === vvv.type && vv.code === '') {
                        let selected = !!value;
                        return {
                            code: '',
                            name: '其他',
                            value: value,
                            selected: selected,
                            organCode: vv.organCode
                        }
                    } else {
                        return vv;
                    }

                })
                return {
                    ...vvv,
                    symptoms
                }
            } else {
                return vvv;
            }

        })
        setOrgans(_organs)
        let _list = _organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
        props.onComplete('head', _list);
        return _list;
    }

    const onPopState = (event: any) => {
        props.onBack();
    }

    const headSelect = () => {
        setHeadSelected(true);
        setChestSelected(false);
        setActiveOrgan('brain');
    }

    const chestSelect = () => {
        setHeadSelected(false);
        setChestSelected(true);
        setActiveOrgan('eye');
    }

    const stomachSelect = () => {
        setActiveOrgan('tooth');
    }

    const othersSelect = () => {
        setOthersSelected(!othersSelected);
    }

    const fourLimbsSelect = () => {
        setFourLimbsSelected(!fourLimbsSelected);
    }

    const symptomsSelected = (val: any, key: number) => {
        if (!val.code) {
            // 其他选项输入
            organList.some((val: any, key: number) => {
                if (activeOrgan === val.type) {
                    const _lastItem = val.symptoms[val.symptoms.length -1] || {};
                    if (_lastItem && _lastItem.code === '') {
                        setValue(_lastItem.value || '');
                        return true;
                    }
                }
            })
            setVisible(true);
            return;
        }
        let _brainCount = 0;
        let _eyeCount = 0;
        let _toothCount = 0;
        const _list = organList.map((item: any) => {
            let _symptoms: any = item.symptoms.map((v: any) => {
                let _selected = !!v.selected;
                if (val.code === v.code) {
                    _selected = !v.selected;
                }
                if (item.type === 'brain') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _brainCount++;
                    }
                } else if (item.type === 'eye') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _eyeCount++;
                    }
                } else if (item.type === 'tooth') {
                    // 输入其他时
                    if (!v.code) {
                        if (v.value) {
                            _selected = true;
                        } else {
                            _selected = false;
                        }
                    }
                    if (_selected) {
                        _toothCount++;
                    }
                }
                return {
                    ...v,
                    selected: _selected
                }
            });
            return {
                ...item,
                symptoms: _symptoms
            }
            // let selected = !!item.selected;
            // if (val.code === item.code) {
            //     selected = true;
            // }
            // return {
            //     selected: selected,
            //     ...item
            // }
        });
        setHeadSelected(_brainCount > 0);
        setChestSelected(_eyeCount > 0);
        setStomachSelected(_toothCount > 0);
        setBrainSelectedCount(_brainCount);
        setEyeSelectedCount(_eyeCount);
        setToothSelectedCount(_toothCount);
        setOrganList(_list);
        const _organs = organs;
        _organs.organs = _list;
        setOrgans(_organs)
        props.onComplete('head', _list);
    }

    const setOrganSelectedActive = (mOrganList?: any) => {
        let _brainCount = 0;
        let _eyeCount = 0;
        let _toothCount = 0;
        let _organList = mOrganList || organList;
        _organList.forEach((item: any) => {
            item.symptoms.forEach((v: any) => {
                let _selected = v.selected;
                if (item.type === 'brain') {
                    if (_selected) {
                        _brainCount++;
                    }
                } else if (item.type === 'eye') {
                    if (_selected) {
                        _eyeCount++;
                    }
                } else if (item.type === 'tooth') {
                    if (_selected) {
                        _toothCount++;
                    }
                }
            });
        });
        setBrainSelectedCount(_brainCount);
        setEyeSelectedCount(_eyeCount);
        setToothSelectedCount(_toothCount);
        setHeadSelected(_brainCount > 0);
        setChestSelected(_eyeCount > 0);
        setStomachSelected(_toothCount > 0);
    }

    return (
        <div className={styles.ae_reporting}>
            <div className={styles.choose_symptom}>
                <div className={styles.content_area}>
                    <div className={styles.sympton_title}>ALK【头颈】常见风险症状：</div>
                    <div className={styles.sympton_content}>
                        {
                            organList.map((val: any, key: number) => {
                                if (activeOrgan === val.type) {
                                    return val.symptoms.map((val: any, iKey: number) => (
                                        <div key={iKey} className={`${val.selected ? styles.active : styles.un_active}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                                    ))
                                }
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.body_title}>
                <div className={styles.body_active}>
                    全部
                </div>
                <div className={styles.body_un_active}>
                    头颈
                </div>
                <div className={styles.body_un_active}>{organMap[activeOrgan] || '未选器官'}</div>
            </div>
            <div className={styles.area_body_container}>
                <img className={styles.area_body} src={blue_body} alt="" />
                <img className={styles.body_organ_brain} src={body_organ_brain} alt="" />
                <img className={styles.body_organ_eye} src={body_organ_eye} alt="" />
                <div className={`${styles.area_base} ${styles.area_head} ${headSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { headSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={headSelected ? organ_brain_blue : organ_brain_purple} alt="" />
                        <div>脑部</div>
                        {
                            brainSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {brainSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    {/* {
                        activeOrgan === 'brain' &&
                        <>
                            <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                {brainIntro}
                            </div>
                        </>
                    } */}
                    <img  className={styles.line_head} src={line_to_brain} alt="" />
                </div>
                <div className={`${styles.area_base} ${styles.area_chest} ${chestSelected ? styles.area_active : styles.area_in_active}`} onClick={ () => { chestSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_eye} src={chestSelected ? organ_eye_blue : organ_eye_purple} alt="" />
                        <div>眼睛</div>
                        {
                            eyeSelectedCount > 0 &&
                            <div className={styles.symptom}>
                                {eyeSelectedCount}
                                <div className={`${styles.area_tr_r}`}></div>
                                <div className={`${styles.area_tr_t}`}></div>
                            </div>
                        }
                    </div>
                    {/* {
                        activeOrgan === 'eye' &&
                        <>
                            <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                {eyeIntro}
                            </div>
                        </>
                    } */}
                    <img  className={styles.line_chest} src={line_to_eye} alt="" />
                </div>
                {/* <div className={`${styles.area_base} ${styles.area_others} ${stomachSelected ? styles.area_active : ''} ${activeOrgan === 'tooth' ? styles.active : styles.in_active}`} onClick={ () => { stomachSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    {
                        toothSelectedCount > 0 &&
                        <div className={styles.ltSelectedCount}>
                            {toothSelectedCount}个症状
                        </div>
                    }
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_tooth} src={organ_tooth} alt="" />
                        <div>口腔</div>
                    </div>
                    <img  className={styles.line_others} src={line_tooth} alt="" />
                </div> */}
                <div onClick={() => { props.onBack() }} className={`${styles.area_base} ${styles.area_four_limbs} ${fourLimbsSelected ? styles.area_active : styles.area_in_active}`}>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={arrow_back} alt="" />
                        <div>返回</div>
                    </div>
                </div>
            </div>
            {/* <div className={styles.sympton_select}>
                <div className={styles.sympton_select_img_wrap}>
                    <img src={sympton_bg} alt="" />
                </div>
                <div className={styles.sympton_select_text_wrap}>
                    <div className={styles.sympton_select_text}>请选择一个或多个与您症状贴近的病症描述：</div>
                    <div className={styles.sympton_select_menu}>
                        {
                            organList.map((val: any, key: number) => {
                                if (activeOrgan === val.type) {
                                    return val.symptoms.map((val: any, iKey: number) => (
                                        <div key={iKey} className={`${val.selected ? styles.menu_active : ''}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                                    ))
                                }
                            })
                        }
                    </div>
                </div>
            </div> */}
            {/* <div className={styles.btns_wrap}>
                <div className={styles.btns_back}>
                    <img className={styles.bootom_top} src={bg_back} alt="" />
                    <div className={styles.text} onClick={() => { props.onBack() }}>返回上一步</div>
                </div>
                <div className={styles.btns_finish_go_on}>
                    <img className={styles.bootom_top} src={bg_finish_go_on} alt="" />
                    <div className={styles.text} onClick={() => { props.onComplete('head', organList) }}>选择完成，继续评测</div>
                </div>
            </div> */}
            <Modal
                visible={visible}
                content={
                    <TextArea
                        placeholder='请输入内容'
                        value={value}
                        onChange={val => {
                            setValue(val)
                        }}
                    />
                }
                // closeOnMaskClick
                closeOnAction
                onClose={() => {
                    setOrganSelectedActive(setOtherValue(value));
                    setVisible(false)
                }}
                actions={[
                    {
                        key: 'confirm',
                        text: '确定',
                    },
                ]}
            >
            </Modal>
        </div>
    )
}

export default withRouter(Chest);